import type { SuperadminTransactionStatus } from '../types';

// Transaction status definitions for superadmin
export const SUPERADMIN_TRANSACTION_STATUSES: Record<string, SuperadminTransactionStatus> = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  PENDING: 'PENDING',
  INITIATED: 'INITIATED',
  CANCELLED: 'CANCELLED',
  DROP: 'DROP',
} as const;

// Status groups for categorization
export const SUPERADMIN_STATUS_GROUPS = {
  SUCCESSFUL: ['SUCCESS'],
  FAILED: ['FAILURE', 'DROP', 'CANCELLED'],
  PENDING: ['PENDING', 'INITIATED'],
} as const;

// Status color mapping
export const getSuperadminStatusColor = (status: string): 'success' | 'error' | 'warning' | 'default' => {
  switch (status) {
    case 'SUCCESS':
      return 'success';
    case 'FAILURE':
    case 'DROP':
    case 'CANCELLED':
      return 'error';
    case 'PENDING':
    case 'INITIATED':
      return 'warning';
    default:
      return 'default';
  }
};

// Status display labels
export const getSuperadminStatusLabel = (status: string): string => {
  switch (status) {
    case 'SUCCESS':
      return 'Success';
    case 'FAILURE':
      return 'Failed';
    case 'PENDING':
      return 'Pending';
    case 'INITIATED':
      return 'Initiated';
    case 'CANCELLED':
      return 'Cancelled';
    case 'DROP':
      return 'Dropped';
    default:
      return status;
  }
};
